import { render, staticRenderFns } from "./about.vue?vue&type=template&id=0861fdd8"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=0861fdd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports